import { ToastrEmitter, ConfirmToastrOptions, BasicToastrOptions, LightToastrOptions } from 'react-redux-toastr';
import axios from 'axios';
import type { NavigateFunction } from 'react-router-dom';

import noop from 'functions/general/noop';
import defaultLocal from 'services/local/defaultLocal';
import promiseWrapper from 'functions/general/promiseWrapper';
import apiHttp from 'services/http/apiHttp';
import type { MainContextInt, MainContextIntBase } from 'routes/types';

const useNavigate: NavigateFunction = () => {
  // This is intentional
};

const defaultDispath = <T,>() => {
  return {a: 0} as T;
};

export const defaultToastr: ToastrEmitter = {
  clean: () => noop(),
  confirm: (_message: string, _options: ConfirmToastrOptions) => noop(),
  error: (_title: string, _message: string, _options?: BasicToastrOptions) => noop(),
  info: (_title: string, _message: string, _options?: BasicToastrOptions) => noop(),
  light: (_title: string, _message: string, _options?: LightToastrOptions) => noop(),
  message: (_title: string, _message: string, _options?: BasicToastrOptions) => noop(),
  removeByType: (_type: string) => noop(),
  success: (_title: string, _message: string, _options?: BasicToastrOptions) => noop(),
  warning: (_title: string, _message: string, _options?: BasicToastrOptions) => noop()
}

export const mainContextDefault: MainContextIntBase = {
  openLoading: (_message: string) => {
    // This is intentional
  },
  closeLoading: noop,
  history: useNavigate,
  dispatch: defaultDispath,
  scrollToTop: () => {
    // This is intentional
  },
  toastr: defaultToastr,
  local: defaultLocal,
  api: apiHttp(axios, promiseWrapper(defaultToastr)),
  used: 0,
  total: 0,
  editMode: false,
  componentName: '',
  showMenu: true as boolean,
  isLoggedIn: false as boolean,
  pendingCredits: false as boolean,
  signIn: false as boolean,
  signUp: false as boolean,
  isLoading: false as boolean,
  message: '' as string,
  isOpen: false as boolean,
  subject: '' as string,
  isOpenContactLogin: false as boolean,
  subjectContactLogin: '' as string,
  name: '' as string,
  sendEmail: false as boolean,
  latinize: (str: string) => str,
  withOpenedSignIn: false as boolean
};

export const mainContextFake: MainContextInt = {
  ...mainContextDefault,
  tutorialBoxes: [],
  tutorialStep: 0,
  nextStep: () => {},
  clearTutorials: () => {},
  tutorial: '',
  setTutorial: (_v: string) => {},
  findOutMore: '',
  setFindOutMore: (_v: string) => {},
  howToConcept: '',
  setHowToConcept: (_v: string) => {}
};

export default mainContextDefault;
